module.exports = __webpack_public_path__ + "static/media/CTLA_1-253w.12d775e9.webp";